
import app from '../../firebase';
import { useRef, useState } from 'react';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import { uploadBytes, ref, getStorage, getDownloadURL } from 'firebase/storage';
import defaultPicture from '../../media/homemoto.png';

export default function Personal({ profile }) {

    // address
    const [house, setHouse]                 = useState();
    const [street, setStreet]               = useState();
    const [barangay, setBarangay]           = useState();
    const [municipality, setMunicipality]   = useState();
    const [province, setProvince]           = useState();
    const [landmark, setLandmark]           = useState();
    
    const picture = useRef(null);

    const updateAddress = () => {

        let address = {
            house,
            street,
            barangay,
            municipality,
            province,
            landmark,
        };
        
        updateDoc(doc(getFirestore(app), 'users', profile[0]), { address });
        return alert('Address Saved!');
    }

    const handlePictureClick = () => {
        picture.current.click();
    }

    const handlePictureChange = async e => {
        await uploadBytes(ref(getStorage(app), `pictures/${profile[0]}`), e.target.files[0])
            .then(() => {
                getDownloadURL(ref(getStorage(app), `pictures/${profile[0]}`))
                    .then(picture => updateDoc(doc(getFirestore(app), `users/${profile[0]}`), { picture }))
            }); window.location.reload();
    }


    return(
        <>
            <div className="container-fluid bg-light p-4">
                <div className="row">
                    <div className="col-md-6 mb-4">
                        <h5>Profile</h5>
                        <div className="d-md-flex align-items-center text-center">
                            <div className="me-4">

                                <img
                                    src={profile && profile[1].picture ? profile[1].picture:defaultPicture}
                                    className="img-fluid rounded-circle shadow mb-4"
                                    onClick={handlePictureClick}
                                    role="button"
                                    style={{ width: 150, height: 150 }}
                                    alt=""
                                />

                                <input
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    ref={picture}
                                    onChange={handlePictureChange}
                                    style={{ display: 'none' }}
                                />

                            </div>
                            <div>
                                <input
                                    type="text"
                                    defaultValue={profile && profile[1].name}
                                    placeholder="Full Name"
                                    className="form-control rounded-pill mb-2"
                                />
                                
                                <input
                                    type="email"
                                    defaultValue={profile && profile[1].email}
                                    placeholder="Email Address"
                                    className="form-control rounded-pill mb-2"
                                />
                                
                            </div>
                        </div>
                    </div>
                    
                    {/* address */}
                    <div className="col-md-6 mb-4">
                        <h5>Address</h5>
                        <input type="text" defaultValue={profile && profile[1].address.house}         className="form-control rounded-pill mb-2" placeholder="House Number"   onChange={data => setHouse(data.target.value)}        />
                        <input type="text" defaultValue={profile && profile[1].address.street}        className="form-control rounded-pill mb-2" placeholder="Street"         onChange={data => setStreet(data.target.value)}       />
                        <input type="text" defaultValue={profile && profile[1].address.barangay}      className="form-control rounded-pill mb-2" placeholder="Barangay"       onChange={data => setBarangay(data.target.value)}     />
                        <input type="text" defaultValue={profile && profile[1].address.municipality}  className="form-control rounded-pill mb-2" placeholder="Municipality"   onChange={data => setMunicipality(data.target.value)} />
                        <input type="text" defaultValue={profile && profile[1].address.province}      className="form-control rounded-pill mb-2" placeholder="Province/City"  onChange={data => setProvince(data.target.value)}     />
                        <input type="text" defaultValue={profile && profile[1].address.landmark}      className="form-control rounded-pill mb-2" placeholder="Landmark"       onChange={data => setLandmark(data.target.value)}     />
                        <button className='btn btn-dark rounded-pill w-100' onClick={updateAddress}>Save Address</button>
                    </div>
                </div>
            </div>
        </>
    )
}